module.exports = __webpack_public_path__ + "static/media/reportIcon.a92bba83.svg";